import { api } from './api';

export const familyApi = {
  get: () => api.get('/family').then((r) => r.data),
  create: (name) => api.post('/family', { name }).then((r) => r.data),
  rename: (name) => api.patch('/family', { name }).then((r) => r.data),

  createInvitation: (invited_email, proposed_role = 'member') =>
    api.post('/family/invitations', { invited_email, proposed_role }).then((r) => r.data),
  revokeInvitation: (id) => api.delete(`/family/invitations/${id}`).then((r) => r.data),
  lookupInvitation: (token) =>
    api.get('/family/invitations/lookup', { params: { token } }).then((r) => r.data),
  publicLookupInvitation: (token) =>
    api.get('/family/invitations/public-lookup', { params: { token } }).then((r) => r.data),
  acceptInvitation: (token) => api.post('/family/invitations/accept', { token }).then((r) => r.data),

  confirmInvitation: (id, { role, account_ids }) =>
    api.post(`/family/invitations/${id}/confirm`, { role, account_ids }).then((r) => r.data),

  updateMember: (userId, { role, account_ids }) =>
    api.put(`/family/members/${userId}`, { role, account_ids }).then((r) => r.data),
  removeMember: (userId) => api.delete(`/family/members/${userId}`).then((r) => r.data),

  myMembership: () => api.get('/family/me').then((r) => r.data),
  myAccounts: () => api.get('/family/accounts').then((r) => r.data),
  myPages: () => api.get('/family/pages').then((r) => r.data),

  memberPages: (userId) => api.get(`/family/members/${userId}/pages`).then((r) => r.data),
  updateMemberPages: (userId, pages) => api.put(`/family/members/${userId}/pages`, { pages }).then((r) => r.data),

  familyAccounts: () => api.get('/accounts').then((r) => r.data),
};